<template>
  <div class="item">
    <div class="item-content">
      <div class="title">{{ layer[`title_${locale}`] }}</div>
      <div class="bar">
        <a target="_blank" :href="makeCatalogLink(layer.code)"><i class="fa fa-book"></i>Catàleg</a>
        <a target="_blank" :href="makeMapLink(layer.code)"><i class="fa fa-map"></i>Mapa</a>
      </div>
      <img :src="'/storage/capturas_capas/' + layer.code + '.png'" alt="">
      <a target="_blank" :href="makeMapLink(layer.code)">
        <div class="item-overlay" style="padding: 25px;">
          <h6 style="width: 100%" class="three-line-text">{{ layer[`description_${locale}`] ? layer[`description_${locale}`] : layer[`title_${locale}`] }}</h6>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
    import {AppConfig} from "../../../appConfig";

    export default {
        name: 'LayerItem',
        props: {
            layer: {
                type: Object
            }
        },
        computed: {
            locale() {
                return this.$i18n.locale
            }
        },
        methods: {
            makeCatalogLink(layerCode) {
                return `${AppConfig.APP_URL}/${this.locale}/catalogo#/layers/${layerCode}`;
            },
            makeMapLink(layerCode) {
                return `${AppConfig.APP_URL}/${this.locale}/visor#/?layers=${layerCode}`;
            }
        }
    }
</script>